import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {getBanners} from '../api/home.api';
import {getStoreInformation} from '../core/localstorage-data';
import type {RootState} from '../redux/store';

interface bannerResponse {
  images: {
    [key: string]: string;
  };
}

interface bannerState {
  banner: bannerResponse;
  loading: boolean;
  error: string;
}

const initialState: bannerState = {
  banner: {
    images: {},
  },
  loading: false,
  error: '',
};

export const fetchBanners = createAsyncThunk(
  'home/fetchBanners',
  async (payload: undefined, thunkApi) => {
    const storeInfomation = getStoreInformation();
    const storeId = storeInfomation?.store_code;
    return getBanners(storeId)
      .then(response => response)
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchBanners.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchBanners.fulfilled, (state, {payload}) => {
      state.loading = false;
      state.banner = payload;
    });
    builder.addCase(fetchBanners.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

export const error = (state: RootState): string => state.homeReducer.error;
export const loading = (state: RootState): boolean => state.homeReducer.loading;
export const bannerResponse = (state: RootState): bannerResponse =>
  state.homeReducer.banner;

export default homeSlice.reducer;
